import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const Navigation = ({ lang, setLang, activeSection }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isHomePage = 
    location.pathname === "/" || 
    location.pathname === `/${lang}` || 
    location.pathname === `/${lang}/`;
  
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);

  const flags = {
    tr: { src: "https://flagcdn.com/w40/tr.png", alt: "Türkçe", label: "TR" },
    en: { src: "https://flagcdn.com/w40/gb.png", alt: "English", label: "EN" },
    ru: { src: "https://flagcdn.com/w40/ru.png", alt: "Русский", label: "RU" }
  };

  const closeMobileMenu = () => {
    const navbar = document.getElementById("bs-example-navbar-collapse-1");
    if (navbar && navbar.classList.contains("in")) {
      navbar.classList.remove("in");
    }
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    closeMobileMenu(); 

    if (isHomePage) {
      const target = document.getElementById(targetId);
      if (target) {
        const headerOffset = 40; 
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    } else {
      navigate(`/${lang}/#${targetId}`);
    }
  };

  const handleLogoClick = (e) => {
    closeMobileMenu(); 
    if (isHomePage) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else {
      window.scrollTo(0, 0);
    }
  };

  const handleLangChange = (selectedLang) => {
    setLang(selectedLang);
    setIsLangMenuOpen(false); 
    closeMobileMenu(); 
  };

  const formatNavText = (textTr, textRu, textEn) => {
    if (lang === "tr") {
      return textTr.toLocaleUpperCase("tr-TR");
    } else if (lang === "ru") {
      return textRu.toLocaleUpperCase("ru-RU"); 
    } else {
      return textEn.toUpperCase();
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <style>
        {`
          #menu ul.nav li a {
            text-transform: none !important; 
          }

          .lang-dropdown-list {
            position: absolute;
            top: 100%;
            left: 15px;
            background-color: #fff;
            list-style: none;
            padding: 8px 0;
            margin: 0;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            border-radius: 4px;
            min-width: 110px;
            z-index: 1000;
          }
          
          @media (min-width: 768px) {
            .lang-flag-btn {
               margin-top: 18px !important;
               padding: 0 !important;
            }
          }

          @media (max-width: 767px) {
            .lang-dropdown-list {
              position: static; 
              margin-top: 5px;
              margin-bottom: 15px;
            }
            .lang-flag-btn {
               margin-top: 5px !important;
               padding: 10px 0 !important;
            }
          }
        `}
      </style>

      <div className="container">
        
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Menüyü Aç/Kapat</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          
          <Link className="navbar-brand" to={`/${lang}`} onClick={handleLogoClick}>
            <img 
              src="/img/omemtechbeyaz.png" 
              alt="Omemtech Logo" 
              className="navbar-logo" 
              fetchPriority="high" /* ÇÖZÜM: LCP önceliği artırıldı */
            />
          </Link>
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            
            <li className={activeSection === "about" ? "active" : ""}>
              <a href="#about" onClick={(e) => handleNavClick(e, "about")} className="page-scroll">
                {formatNavText("Hakkımızda", "О нас", "About Us")}
              </a>
            </li>
            
            <li className={activeSection === "portfolio" ? "active" : ""}>
              <a href="#portfolio" onClick={(e) => handleNavClick(e, "portfolio")} className="page-scroll">
                {formatNavText("Ürünlerimiz", "Продукция", "Products")}
              </a>
            </li>
            
            <li className={activeSection === "contact" ? "active" : ""}>
              <a href="#contact" onClick={(e) => handleNavClick(e, "contact")} className="page-scroll">
                {formatNavText("İletişim", "Контакты", "Contact")}
              </a>
            </li>

            <li 
              style={{ position: 'relative', paddingLeft: '15px' }} 
              onMouseLeave={() => setIsLangMenuOpen(false)} 
            >
              <button 
                className="lang-flag-btn" 
                onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
                title="Dil Seçin / Choose Language"
              >
                <img 
                  src={flags[lang]?.src || flags.tr.src} 
                  width="26" 
                  alt={flags[lang]?.alt} 
                  style={{ borderRadius: '3px', boxShadow: '0 2px 5px rgba(0,0,0,0.3)' }} 
                />
                <span style={{ fontSize: '12px', color: '#ccc' }}>▼</span>
              </button>

              {isLangMenuOpen && (
                <ul className="lang-dropdown-list">
                  {Object.keys(flags).map((code) => (
                    <li key={code}>
                      <button
                        onClick={() => handleLangChange(code)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          padding: '8px 15px',
                          background: lang === code ? '#f0f0f0' : 'transparent', 
                          border: 'none',
                          cursor: 'pointer',
                          textAlign: 'left',
                          gap: '10px'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = lang === code ? '#f0f0f0' : 'transparent'}
                      >
                        <img 
                          src={flags[code].src} 
                          width="22" 
                          alt={flags[code].alt} 
                          style={{ borderRadius: '2px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} 
                        />
                        <span style={{ color: '#333', fontSize: '14px', fontWeight: lang === code ? 'bold' : 'normal' }}>
                          {flags[code].label}
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>

          </ul>
        </div>

      </div>
    </nav>
  );
};